var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.config.privacy_agreement
    ? _c("div", { staticClass: "agreement-popup" }, [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("web_tips_title"))),
            ]),
            _c(
              "i18n",
              {
                staticClass: "text",
                attrs: { path: "text_agreement", tag: "div" },
              },
              [
                _vm._t("0", function () {
                  return [_vm._v("123")]
                }),
                _vm._t("1", function () {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "link",
                        on: {
                          click: function ($event) {
                            return _vm.jumpUrl("privacy")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("link_privacy")))]
                    ),
                  ]
                }),
                _vm._t("2", function () {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "link",
                        on: {
                          click: function ($event) {
                            return _vm.jumpUrl("agreement")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("link_agreement")))]
                    ),
                  ]
                }),
              ],
              2
            ),
            _c("div", { staticClass: "button btn", on: { click: _vm.agree } }, [
              _vm._v(_vm._s(_vm.$t("text_btn_agree"))),
            ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }